import React from 'react';
import ImgLock from '../lock.png';

interface Props {
  children: React.ReactNode;
}
const Default: React.FC<Props> = ({ children }) => {
  return (
    <>
      <div style={{ textAlign: 'center', background: '#F1F3F6', padding: 20, margin: 20, borderRadius: 10 }}>
        <div style={{ fontSize: 13, fontWeight: 'bold', height: 25 }}>
          <img
            style={{ width: 20, height: 20, marginBottom: -4, marginRight: 3 }}
            src={ImgLock}
            loading="lazy"
            alt={'site seguro'}
          />
          Pagamento seguro
        </div>
        <div style={{ fontSize: 12 }}>Você está em um site seguro e seus dados estão protegidos por criptografia</div>
      </div>
      {children}
    </>
  );
};
export default Default;
